import './ActionsPopoverMenu.css'
import { Popover, PopoverPanel, PopoverButton } from '@headlessui/react'
import { useEffect } from 'react'
import cx from 'classnames'
import { MeatballsIcon } from '../icons'

export type ActionItem = {
  label: string
  icon?: React.ReactNode
  onClick: () => void
  disabled?: boolean
  className?: string
}

type ActionsPopoverMenuProps = {
  actions: ActionItem[]
  anchor?: 'top end' | 'bottom end' | 'top' | 'bottom' | 'left' | 'right'
  className?: string
  panelClassName?: string
}

const ActionsPopoverMenuItem = ({ label, icon, onClick, disabled, className }: ActionItem) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cx('actions-popover-menu-item', className)}
    >
      <div className="actions-popover-menu-item-content">
        {icon && <span className="actions-popover-menu-item-icon">{icon}</span>}
        {label}
      </div>
    </button>
  )
}

const ActionsPopoverMenuContent = ({
  actions,
  close
}: {
  actions: ActionItem[]
  close: () => void
}) => {
  useEffect(() => {
    const handleScroll = () => {
      close()
    }

    // Listen to scroll events on window and all scrollable containers
    window.addEventListener('scroll', handleScroll, true)
    window.addEventListener('wheel', handleScroll, true)

    return () => {
      window.removeEventListener('scroll', handleScroll, true)
      window.removeEventListener('wheel', handleScroll, true)
    }
  }, [close])

  return (
    <ul>
      {actions.map((action, index) => (
        <li key={index}>
          <ActionsPopoverMenuItem {...action} />
        </li>
      ))}
    </ul>
  )
}

export function ActionsPopoverMenu({
  actions,
  anchor = 'top end',
  className,
  panelClassName
}: ActionsPopoverMenuProps) {
  return (
    <Popover className={cx('actions-popover-menu', className)}>
      <PopoverButton
        className={({ open }) => {
          return cx('icon-btn-base btn-neutral icon-btn-sm', {
            'actions-popover-menu-trigger-open': open
          })
        }}
      >
        <MeatballsIcon className="size-6" />
      </PopoverButton>

      <PopoverPanel
        transition
        anchor={anchor}
        className={cx('actions-popover-menu-panel', panelClassName)}
      >
        {({ close }) => <ActionsPopoverMenuContent actions={actions} close={close} />}
      </PopoverPanel>
    </Popover>
  )
}
